import type { CheckSummaryDto } from '@ops-monitor/shared';

import { StatusDot } from './StatusDot';

/** Relative "N s/min/h ago" for the tile footer. */
function ago(iso: string | null): string {
  if (!iso) return 'ещё не запускался';
  const sec = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (sec < 90) return `${sec} с назад`;
  if (sec < 5400) return `${Math.round(sec / 60)} мин назад`;
  if (sec < 172_800) return `${Math.round(sec / 3600)} ч назад`;
  return `${Math.round(sec / 86_400)} дн назад`;
}

export function CheckTile({ check, onOpen }: { check: CheckSummaryDto; onOpen: (check: CheckSummaryDto) => void }) {
  return (
    <button type="button" className={`check-tile check-tile--${check.status}`} onClick={() => onOpen(check)} title={check.why}>
      <div className="check-tile__head">
        <span className="check-tile__title">{check.title}</span>
        <StatusDot status={check.status} />
      </div>
      <div className="check-tile__text">{check.text}</div>
      <div className="check-tile__meta">
        {ago(check.ranAt)} · каждые {check.intervalSec < 60 ? `${check.intervalSec} с` : `${Math.round(check.intervalSec / 60)} мин`}
        {check.error ? ' · ошибка' : ''}
      </div>
    </button>
  );
}
